<template>
  <div class="container mt-3">
    <div class="row">
      <div class="col s12">
        <div v-show="!validKey">
          Invalid key
        </div>

        <div v-show="validKey" class="card">
          <div class="card-title primary white-text">
            <i class="material-icons icon">card_membership</i>
            Create your account
          </div>

          <div class="card-content">
            <div class="row">
              <div class="input-field col s12 m6">
                <input
                  autofocus
                  type="text"
                  id="email"
                  v-model="editedItem.email"
                >
                <label for="email">Your email address</label>
                <span class="helper-text red-text">{{ (formErrors.email !== '') ? formErrors.email : '' }}</span>
              </div>

              <div class="input-field col s12 m6">
                <input
                  type="text"
                  id="phone"
                  v-model="editedItem.phone"
                >
                <label for="phone">Phone number</label>
                <span class="helper-text red-text">{{ (formErrors.phone !== '') ? formErrors.phone : '' }}</span>
              </div>

              <div class="input-field col s12">
                Already have an account with us?<br>
                <a
                  class="waves-effect waves-light btn primary"
                  :disabled="saveInProgress"
                  @click="loginInstead"
                >
                  <div v-if="saveInProgress" class="saving-animation">
                    <div class="lds-ripple">
                      <div></div>
                      <div></div>
                    </div>
                  </div>
                  <i v-if="!saveInProgress" class="material-icons right">chevron_right</i>
                  Login
                </a>
                <div class="clearfix"></div>
              </div>

              <div class="input-field col s12">
                <input
                  type="text"
                  id="name"
                  v-model="editedItem.name"
                >
                <label for="name">Your Name</label>
                <span class="helper-text">Parent's/Adult's name</span>
                <span class="helper-text red-text">{{ (formErrors.name !== '') ? formErrors.name : '' }}</span>
              </div>

              <div class="input-field col s12 m6">
                <input
                  type="text"
                  id="username"
                  v-model="editedItem.username"
                >
                <label for="username">Create a username</label>
                <span class="helper-text">You will need this to manage and renew your subscriptions later</span>
                <span class="helper-text red-text">{{ (formErrors.username !== '') ? formErrors.username : '' }}</span>
              </div>

              <div class="input-field col s12 m6">
                <input
                  type="password"
                  id="password"
                  v-model="editedItem.password"
                >
                <label for="password">Password</label>
                <span class="helper-text">Password must be 8-30 characters. It can contain alphabets, numbers and any of these special characters !@#^$%</span>
                <span class="helper-text red-text">{{ (formErrors.password !== '') ? formErrors.password : '' }}</span>
              </div>
              <div class="clearfix"></div>

              <div class="input-field col s12 m6">
                <input
                  type="text"
                  id="childName"
                  v-model="editedItem.childName"
                >
                <label for="childName">Who is this subscription for?</label>
                <span class="helper-text">Child's Name</span>
                <span class="helper-text red-text">{{ (formErrors.childName !== '') ? formErrors.childName : '' }}</span>
              </div>

              <div class="input-field col s12 m6">
                <input
                  type="text"
                  class="datepicker"
                  id="dateOfBirth"
                  readonly
                  :placeholder="datePickerFocus ? 'Press enter to open date picker' : null"
                  @focus="datePickerFocus = true"
                  @blur="datePickerFocus = false"
                  v-model.lazy="editedItem.dateOfBirth"
                >
                <label for="dateOfBirth">When was the recipient born?</label>
                <span class="helper-text">We'll be sure to send a little gift!</span>
                <span class="helper-text red-text">{{ (formErrors.dateOfBirth !== '') ? formErrors.dateOfBirth : '' }}</span>
              </div>
            </div>
          </div>
        </div>

        <div v-show="validKey" class="card mt-3">
          <div class="card-title primary white-text">
            <i class="material-icons icon">add_location</i>
            Where should we send the books?
          </div>

          <div class="card-content">
            <div class="row">
              <div class="input-field col s12">
                <textarea
                  id="address"
                  v-model="editedItem.address"
                  class="materialize-textarea"
                ></textarea>
                <label for="address">Address</label>
                <span class="helper-text red-text">{{ (formErrors.address !== '') ? formErrors.address : 'House / Flat no, Locality' }}</span>
              </div>

              <div class="input-field col s12">
                <input
                  type="text"
                  id="landmark"
                  v-model="editedItem.landmark"
                >
                <label for="landmark">Landmark</label>
                <span class="helper-text red-text">{{ (formErrors.landmark !== '') ? formErrors.landmark : '' }}</span>
              </div>

              <div class="input-field col s12 m6">
                <input
                  type="text"
                  id="city"
                  v-model="editedItem.city"
                  readonly
                >
                <span class="suffix" style="top:0.2rem;">
                  <i class="material-icons grey-text text-lighten-1" style="font-size:1.5rem;">lock</i>
                </span>
                <label for="city">City</label>
                <span class="helper-text red-text">{{ (formErrors.city !== '') ? formErrors.city : '' }}</span>
              </div>

              <div class="input-field col s12 m6">
                <input
                  type="text"
                  id="pincode"
                  v-model="editedItem.pincode"
                >
                <label for="pincode">Postal Code</label>
                <span class="helper-text red-text">{{ (formErrors.pincode !== '') ? formErrors.pincode : '' }}</span>
              </div>

              <div class="input-field col s12 m6">
                <input
                  type="text"
                  id="state"
                  v-model="editedItem.state"
                >
                <label for="state">State</label>
                <span class="helper-text red-text">{{ (formErrors.state !== '') ? formErrors.state : '' }}</span>
              </div>

              <div class="input-field col s12 m6">
                <input
                  type="text"
                  id="country"
                  v-model="editedItem.country"
                  readonly
                >
                <span class="suffix" style="top:0.2rem;">
                  <i class="material-icons grey-text text-lighten-1" style="font-size:1.5rem;">lock</i>
                </span>
                <label for="country">Country</label>
                <span class="helper-text red-text">{{ (formErrors.country !== '') ? formErrors.country : '' }}</span>
              </div>
            </div>
          </div>

          <div class="card-action grey lighten-3">
            <a
              class="waves-effect waves-light btn primary right"
              :disabled="saveInProgress"
              @click="registerNewUser"
            >
              <div v-if="saveInProgress" class="saving-animation">
                <div class="lds-ripple">
                  <div></div>
                  <div></div>
                </div>
              </div>
              <i v-if="!saveInProgress" class="material-icons right">chevron_right</i>
              Continue
            </a>
            <div class="clearfix"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// Import the API functions
import httpApi from '@/utils/api'

export default {
  props: ['k'],

  data () {
    return {
      // Loading status
      loadingAnimation: true,

      uniqueKey: '',

      validKey: true,

      saveInProgress: false,

      datePickerFocus: false,

      // Form bound variables being edited
      editedItem: {
        id: 0,
        username: '',
        password: '',
        childName: '',
        dateOfBirth: '',
        name: '',
        address: '',
        landmark: '',
        deliveryCity: '',
        city: '',
        state: '',
        country: 'India',
        pincode: '',
        email: '',
        phone: ''
      },

      // Error holders for form fields
      formErrors: {
        username: null,
        password: null,
        childName: null,
        dateOfBirth: null,
        name: null,
        address: null,
        landmark: null,
        city: null,
        deliveryCity: null,
        state: null,
        country: null,
        pincode: null,
        email: null,
        phone: null
      },

      defaultFormErrors: {
        username: null,
        password: null,
        childName: null,
        dateOfBirth: null,
        name: null,
        address: null,
        landmark: null,
        city: null,
        deliveryCity: null,
        state: null,
        country: null,
        pincode: null,
        email: null,
        phone: null
      }
    }
  },

  mounted () {
    // Check that invoice doesn't have a linked userID (else it means that user has already registered with this unique link)
    if (this.k !== '') {
      this.uniqueKey = this.k

      httpApi.callWithKey({
        url: 'subscription/pending?k=' + this.uniqueKey,
        method: 'get'
      })
        .then((resp) => {
          // Assign details
          this.editedItem.name = resp.data.deliveryName
          this.editedItem.city = resp.data.deliveryAddress
          this.editedItem.deliveryCity = resp.data.deliveryCity
          this.editedItem.email = resp.data.deliveryEmail
          this.editedItem.phone = resp.data.deliveryPhone

          setTimeout(() => {
            var elems1 = document.querySelectorAll('.datepicker')
            // eslint-disable-next-line
            var maxDate = new Date()
            // eslint-disable-next-line
            var instances1 = M.Datepicker.init(elems1, {
              // Datepicker within a modal looks wrong, if not placed on body
              container: 'body',
              format: 'dd mmm yyyy',
              maxDate: maxDate,
              // 25+ year olds are not kids, right?
              yearRange: [(maxDate.getFullYear() - 25), maxDate.getFullYear()]
            })

            // eslint-disable-next-line
            M.updateTextFields()
          }, 500)
        })
        // If an error occurs
        .catch((err) => {
          this.validKey = false

          // Show error message
          this.$store.dispatch('SHOW_STATUS_MESSAGE', {
            color: 'error',
            message: err.message
          })
        })
    }
  },

  methods: {
    loginInstead () {
      this.$router.push('/' + this.uniqueKey)
    },

    registerNewUser () {
      this.saveInProgress = true

      // Validate user input data
      let regEmail = /^([A-Za-z0-9_\-.])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,})$/
      let valid = true

      if (this.editedItem.email === '') {
        this.formErrors.email = 'Please enter a valid email address'
        valid = false
      } else if (regEmail.test(this.editedItem.email) === false) {
        this.formErrors.email = 'Please enter a valid email address'
        valid = false
      } else {
        this.formErrors.email = ''
      }

      if (this.editedItem.phone === '') {
        this.formErrors.phone = 'Please enter a phone number'
        valid = false
      } else {
        this.formErrors.phone = ''
      }

      if (this.editedItem.name === '') {
        this.formErrors.name = 'Please enter the parent\'s / adult\'s name'
        valid = false
      } else {
        this.formErrors.name = ''
      }

      if (this.editedItem.username === '') {
        this.formErrors.username = 'Please enter a username'
        valid = false
      } else {
        this.formErrors.username = ''
      }

      if (this.editedItem.password === '') {
        this.formErrors.password = 'Please enter a password'
        valid = false
      } else {
        this.formErrors.password = ''
      }

      if (this.editedItem.childName === '') {
        this.formErrors.childName = 'Please enter recipient\'s name'
        valid = false
      } else {
        this.formErrors.childName = ''
      }

      if (this.editedItem.dateOfBirth === '') {
        this.formErrors.dateOfBirth = 'Please enter recipient\'s date of birth'
        valid = false
      } else {
        this.formErrors.dateOfBirth = ''
      }

      if (this.editedItem.address === '') {
        this.formErrors.address = 'Please enter an address'
        valid = false
      } else {
        this.formErrors.address = ''
      }

      if (this.editedItem.landmark === '') {
        this.formErrors.landmark = 'Please enter a landmark'
        valid = false
      } else {
        this.formErrors.landmark = ''
      }

      if (this.editedItem.pincode === '') {
        this.formErrors.pincode = 'Please enter the postal code'
        valid = false
      } else {
        this.formErrors.pincode = ''
      }

      if (this.editedItem.state === '') {
        this.formErrors.state = 'Please enter the state'
        valid = false
      } else {
        this.formErrors.state = ''
      }

      if (valid) {
        let dataBody = {
          uniqueKey: this.uniqueKey,
          username: this.editedItem.username,
          password: this.editedItem.password,
          childName: this.editedItem.childName,
          dateOfBirth: this.editedItem.dateOfBirth,
          name: this.editedItem.name,
          address: this.editedItem.address,
          landmark: this.editedItem.landmark,
          city: this.editedItem.city,
          deliveryCity: this.editedItem.deliveryCity,
          state: this.editedItem.state,
          country: this.editedItem.country,
          pincode: this.editedItem.pincode,
          email: this.editedItem.email,
          phone: this.editedItem.phone,
          sendOffers: 0
        }

        // Save to API
        httpApi.callWithKey({
          url: 'subscription/register',
          data: dataBody,
          method: 'post'
        })
          .then((resp) => {
            // Save token to localStorage (like login)
            localStorage.setItem('user-token', resp.data.token)
            this.$store.commit('AUTH_SUCCESS', resp)

            // Show success message
            this.$router.push('/confirm-details/' + this.uniqueKey)
          })
          .catch((err) => {
            // Hide loading animation
            this.saveInProgress = false

            // Empty older errors
            this.formErrors = Object.assign({}, this.defaultFormErrors)

            // Show new errors. Timeout required, else fails
            setTimeout(() => {
              let errors = Object.keys(err.data)
              errors.forEach((value, key) => {
                // Set error message
                this.formErrors[value] = err.data[value]
              })
            }, 100)

            // There could be multiple errors in an array. Convert to a string
            let errorString = Object.values(err.data)
            errorString = errorString.join(', ')

            // Show error message
            this.$store.dispatch('SHOW_STATUS_MESSAGE', {
              color: 'error',
              message: errorString
            })
          })
      } else {
        this.saveInProgress = false
      }
    }
  }
}
</script>
